<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-top
          class="d-md-flex"
          outlined
          :useBtnList="[
            'btnSearch' //check
          ]"
          @btnSearch="btnSearch()"
        >
          <template v-slot:body>
            <v-layout column>
              <v-row no-gutters class="center pa-2 pb-0">
                <i-label :label="'Date : '" class="pl-2"/>
                <v-col cols="12" md="2">
                   <DxDateBox                        
                        :value="movDate"
                        height="30px"
                        display-format="yyyy-MM-dd"
                        :acceptCustomValue="false"
                        @value-changed="e => {movDate = e.value && getStrFormat(e.value)}"
                    />
                
                </v-col>

                <v-col cols="12" md="2">
                  <v-select
                    label="Department"
                    v-model="dept"
                    readonly
                    :items="listDept"
                    :item-value="`code`"
                    :item-text="`name`"
                    color="primary"
                    class="required mx-1 rounded-0"
                    :prepend-inner-icon="'$search'"
                    dense
                    outlined
                  ></v-select>
                </v-col>

                <v-col cols="12" md="2">
                  <v-select
                    label="Group"
                    v-model="group"
                    :items="listGroup"
                    :item-value="`code`"
                    :item-text="`name`"
                    color="primary"
                    class="required mx-1 rounded-0"
                    :prepend-inner-icon="'$search'"
                    dense
                    outlined
                    @change="loadTeam($event)"
                  ></v-select>
                </v-col>

                <v-col cols="12" md="2">
                  <v-select
                    label="Team"
                    v-model="team"
                    :items="listTeam"
                    :item-value="`code`"
                    :item-text="`name`"
                    color="primary"
                    class="required mx-1 rounded-0"
                    :prepend-inner-icon="'$search'"
                    dense
                    outlined
                  ></v-select>
                </v-col>

                <i-button :text="'C/E Confirm'" :isCustom="true" v-if = "btnChief" :icon="'apply'" role="" class="pl-2" @click="btnChiefConfirm" />

                <i-button :text="'Caption Confirm'" :isCustom="true" v-if = "btnCaption" :icon="'apply'" role="" class="pl-2" @click="btnCaptionConfirm" />
              </v-row>
            </v-layout>
          </template>
        </i-card-top>
      </v-col>
    </v-row>

    <v-row no-gutters class="px-2 align-center"  style="height: 50px;">
        <v-col cols="12">
          <v-radio-group
            v-model="searchType"
            row
            hide-details
            class="font-weight-bold ml-5"
          >
            <v-radio value="P" >
              <template v-slot:label>
                <span class="blue--text font-weight-bold">
                  PLAN
                </span>
              </template>
            </v-radio>

            <v-radio value="A">
              <template v-slot:label>
                <span class="red--text font-weight-bold">
                  ACTUAL
                </span>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

    <v-row no-gutters>
      <v-col cols="12" class="pa-2">
        <i-card-vertical
          style="color: black"
          headerTitle=" Work plan and actual management"
          :useBtnList="[
            'btnAdd', //New
            'btnSave', //Save
            'btnDelete' //Delete
          ]"
          @btnAdd="btnAdd()"
          @btnSave="btnSave()"
          @btnDelete="btnDelete()"
        >
          <template v-slot:body>
            <v-layout column>
              <v-col cols="12" class="pa-0">
                <DxDataGrid
                id="bas0010MainGrid"
                  class="listBox"
                  :ref="dxDataGridRef"
                  :data-source="bas0010MainGrid"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-resizing="true"
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true"
                  :show-borders="true"
                  :width="grid.width"
                  :show-row-lines="true"
                  key-expr="id"
                  :focused-row-enabled="true"
                  :disablePagination="false"
                  :column-hiding-enabled="false"
                  :column-auto-width="true"
                  :on-row-inserted="e => e.component.navigateToRow(e.key)"
                  @editing-start="bas0010EditingStart"
                  @cellPrepared="cellPrepared"
                  @editor-preparing="onEditorPreparing"
                  @init-new-row="onInitNewRow"
                  
                >
                  <DxPaging :enabled="false" />
                   <DxEditing :allow-updating="true" :allow-adding="true" mode="cell" />
                   <DxSelection select-all-mode="allMode" :show-check-boxes-mode="checkBoxesMode" mode="multiple"                    
                   />

                    <!-- readonly -->
                    <DxColumn data-field="empNm" caption="Name" width="150" alignment="left" :allow-editing="false" />
                    <DxColumn data-field="empNo" caption="Code" width="100" alignment="center" :allow-editing="false" />
                  
                    <!-- editable -->
                    <DxColumn
                      data-field="gunte"
                      caption="Absent"
                      width="160"
                      alignment="center"
                    >
                      <DxLookup
                        :data-source="listGunte"
                        display-expr="name"
                        value-expr="code"
                      />
                    </DxColumn>

                    <DxColumn
                    data-field="shipNo"
                    :caption="$t('Ship')"
                    width="100"
                    data-type="string"
                    alignment="center"
                    css-class="devest-grid-header-require"
                    :allow-editing="true"
                    
                  >
                    <DxLookup
                          :data-source="listShip"
                          value-expr="code"
                          display-expr="code"
                          :search-enabled="true"
                        />
                   
                  </DxColumn>
                  <DxColumn
                    data-field="sun"
                    caption="Work hour Type"
                    width="120"
                    alignment="center"
                    
                  >
                    <DxLookup
                      :data-source="listSun"
                      display-expr="name"
                      value-expr="code"
                    />
                  </DxColumn>
                    <DxColumn data-field="block" caption="Block" width="80" alignment="center" :allow-editing="true" />

                    <DxColumn
                      data-field="workAct"
                      caption="Working"
                      width="260"
                      alignment="left"
                    >
                      <DxLookup
                        :data-source="listWorkActAll"
                        value-expr="code"
                        display-expr="name"
                        :search-enabled="true"
                      />
                    </DxColumn>
                    <DxColumn
                      data-field="wkPlace"
                      caption="Place"
                      width="180"
                    >
                      <DxLookup
                        :data-source="listPlace"
                        display-expr="name"
                        value-expr="code"
                      />
                    </DxColumn>

                    <DxColumn
                      data-field="ftime"
                      caption="Begin"
                      width="70"
                      alignment="center"
                      :set-cell-value="setFtime"
                     
                    />
                    <DxColumn
                      data-field="ttime"
                      caption="End"
                      width="70"
                      alignment="center"
                      :set-cell-value="setTtime"
                     
                    />

                    <!-- computed / placeholder -->
                    <DxColumn data-field="total" caption="Total" width="80" alignment="center" :allow-editing="false" />

                    <!-- readonly -->
                    <DxColumn data-field="seq" caption="Seq" width="50" alignment="center" :allow-editing="false" />

                    <DxColumn data-field="rmk" :caption="$t('')" width="auto" data-type="string" alignment="left" :allow-editing="false" />
                    
                </DxDataGrid>
              </v-col>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn, DxLookup, DxSelection, DxPager } from 'devextreme-vue/data-grid'
import iButton from '@/components/common/iButton'
import DxDateBox from 'devextreme-vue/date-box'
import themes from 'devextreme/ui/themes'
import ICardVertical from '@/components/common/iCardVertical.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message
import dayjs from 'dayjs'
import { 
         getPlace, 
         getShipNo, 
         getDept,
         getGroup,
         getTeam,
         getGunte,
         getWorkActShip,
         getWorkActExShip,
         getWorkActIndirect,
         searchPlanList,
         searchActualList,
         searchPlanList_SUB,
         searchActualList_SUB
        } from '@/api/view/pp/20/v20a7000.js'
import {getDateFormat, getCurrentDate } from '@/utils/common.js'

export default {
  name: 'v20a7000pc',
  mixins: [baseview, BaseDataGrid],

  components: {
    ICardVertical,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxLookup,
    DxSelection,
    DxPager,
    iButton
  },
  data() {
    return {
      dxDataGridRef: 'dxDataGridRef',
      bas0010MainGrid: [],
      listClickData: null,

      listFuelOil: [
        {code: 'M', name: 'Ship moving'},
        {code: 'S', name: 'Support'},
      ],
      checkBoxesMode: 'onClick', // themes.current().startsWith('material') ? 'always' : 'onClick',
      //Common code combo box list
      codegrList: [],

      //Date
      modal_from: '',
      modal_to: '',
  
      fday: '',
      tday: '',
      //Time select
      fhhmm: null,
      thhmm: null,
      modal_ftime: false,
      modal_ttime: false,

      dept: '',
      listDept: [],

      group: '',
      listGroup: [],

      team: '',
      listTeam: [],

      searchType: 'P',

      listSun: [
        { code: '1', name: 'Ship' },
        { code: '2', name: 'Except Ship' },
        { code: '3', name: 'Indirect' }
      ],

      listGunte: [],

      listWorkActAll: [],
      workActCache: {},

      listShip: [],
      listRShip: [],
      shipNo: '',

      fjangso: '',
      tjangso: '',
      listPlace: [],

      // movDate: moment().format('YYYY-MM-DD'),
      movDate: '',
      format: '##:##',
      empCaption: '',
      btnCaption: false,
      empChief: '',
      btnChief: false,
      countChief: 0,
      countCaption: 0,
      countAll: 0,
      writeYn: this.$gUtil.getWriteYn(),
    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.dxDataGridRef)
    },


  },
  methods: {
    getStrFormat(date) {
      this.movDate = date
      return getDateFormat(date)
    }, 
    /// add neww row 
    onInitNewRow(e) {
        const grid = this.gridMainInstance
        const focusedIndex = grid.option('focusedRowIndex')
        const row = grid.getVisibleRows()?.[focusedIndex]?.data

        if (!row) return

        e.data.empNo = row.empNo
        e.data.empNm = row.empNm
        e.data.fday = this.movDate
        e.data.tday = this.movDate
      },
    // getTeam  
    async loadTeam(group) {
        const result = await getTeam({
          group: group
        })

        this.listTeam = result.list

        this.listTeam = result.list || []

        // 
        if (group && group.startsWith('84')) {
          const allTeam = this.listTeam.find(x => x.code === '%')

          if (allTeam) {
            this.team = allTeam.code
          }
        } else {
          this.team = ''
        }

      },
      
    // setBegin time
    async setFtime(newData, value, currentRowData) {

      if (!this.isValidTime(value)) {

        this.vToastify(
          'Please input correct time format. Example: 0730, 1700',
          'warn'
        )

        newData.ftime = ''
        return
        }

        newData.ftime = value
      },
    // setFinish time
    async setTtime(newData, value, currentRowData) {

      if (!this.isValidTime(value)) {

      this.vToastify(
        'Please input correct time format. Example: 0730, 1700',
        'warn'
      )

      newData.ttime = ''
      return
      }

      newData.ttime = value
      },
    //check time format
    isValidTime(value) {

      if (!value) return false

      if (value.length !== 4) return false

      if (!/^\d{4}$/.test(value)) return false

      const hh = Number(value.substring(0, 2))
      const mm = Number(value.substring(2, 4))

      return (
        hh >= 0 &&
        hh <= 23 &&
        mm >= 0 &&
        mm <= 59
      )
      },
      //// work act
      async buildWorkActAll(gridData) {
          
          // =========================
          // 1. base lists
          // =========================
          const ship = this.listWorkActShip || []
          const indirect = this.listWorkActIndirect || []

          // =========================
          // 2. collect unique shipNo
          // =========================
          const shipNos = [
            ...new Set(
              gridData
                .map(x => x.shipNo)
                .filter(Boolean)
            )
          ]

          // =========================
          // 3. call API batch
          // =========================
          const apiResults = await Promise.all(
            shipNos.map(sn => getWorkActExShip({
              shipNo: sn,
              respCd: this.group
            }))
          )

          let exShip = []

          apiResults.forEach(res => {
            const list = (res.list || []).map(x => ({
              code: String(x.code).trim(),
              name: x.name
            }))
            exShip = exShip.concat(list)
          })

          // =========================
          // 4. merge all
          // =========================
          this.listWorkActAll = [
            ...ship,
            ...indirect,
            ...exShip
          ]

        },
    // set Combo  
    async setCombo() {


      // getShipNo
      const ship = async () => {
          const result = await getShipNo({})
          
          this.listShip = (result.list || []).map(item => ({
              code: String(item.code).trim(),
              name: item.name
          }))
         
      }

      // getDept
      let paramsDept = { userId: this.$store.state.user.userId }
      const loadDept = async () => {
          const result = await getDept(paramsDept)
          this.listDept = result.list
          this.dept = 'B1'

      }

      // getResp
      let paramsGroup = { dept: 'B1' }
      const loadGroup = async () => {
          const result = await getGroup(paramsGroup)
          this.listGroup = result.list

      }

      //getGunte
      const gunte = async () => {
        await getGunte({}).then(result => {
          result.list.forEach(item => {
            this.listGunte.push({
              code: item.code,
              name: item.name
            })
            //console.log('gunte:', this.listGunte)
          })
        })
      }
      
      // getPlace
      const place = async () => {
          const result = await getPlace({})
          
          this.listPlace = (result.list || []).map(item => ({
              code: String(item.code).trim(),
              name: item.name
          }))
         
      }

      const workActShip = async () => {
        const res = await getWorkActShip({})
        this.listWorkActShip = (res.list || []).map(x => ({
          code: x.code,
          name: x.name
        }))
      }

      const workActIndirect = async () => {
        const res = await getWorkActIndirect({
          respCd: this.group
        })

        this.listWorkActIndirect = (res.list || []).map(x => ({
          code: x.code,
          name: x.name
        }))
      }
      
      //  
      console.log('before Promise.all')
   
      await Promise.all([ship(), loadDept(), loadGroup(), place(),gunte(),workActShip(), workActIndirect()])
        .catch(ex => {
          //    this.$qMsgBox.show(this, this.$gUtil.getSqlError(ex), ['ok']);
        })
        .finally(() => {
          this.$qLoading.hide()
        })
    },
    //PK part modification[edit] function control
    bas0010EditingStart(e) {
      //  this.gridMainInstance.selectRows(e.data.id, true)
      // if (e.data.__created__ === false) {
      //   if ( e.column.dataField === 'shipno' || e.column.dataField === 'fday' || e.column.dataField === 'fhhmm' ) {
      //     e.cancel = true
      //   }
      // } else {
      //   if (e.column.dataField === 'shipnm' ) {
          // e.cancel = true
      //   }
      // }
    },
    cellPrepared(e) {
      // if (e.rowType === 'data') {
      //   if (e.rowType === 'data' && e.rowIndex >= 0) {
      //     // console.log('e.data.__created__', e.data.__created__)
      //     // if (!e.data.__created__) {
      //       // if ( e.column.dataField === 'shipno' || e.column.dataField === 'fday' || e.column.dataField === 'fhhmm')  {
      //         e.cellElement.classList.add('cancel-editable-cell')
      //       // }
      //     // }
      //   }
      // }
    },
    frDaySelect(newData , value , currentRowData){
      // this.dataList[currentRowData.id - 1].fday = getDateFormat(value)
      newData.fday = getDateFormat(value)
    },
    toDaySelect(newData , value , currentRowData){
      newData.tday = getDateFormat(value)
    },

    btnSearch() {
      this.doSearchMainList()

    },
    

    async doSearchMainList(event) {
      this.bas0010MainGrid = []
      this.listClickData = null

      const params = {
        date: this.movDate.replace(/-/g, ''),
        group: this.group,
        jo: this.team ? this.team.substring(0, 2) : '',
        gr: this.team ? this.team.slice(-1) : ''
      }

      this.openLoading('searching')

      try {
        let res

        if (this.searchType === 'P') {
          res = this.group && !this.group.startsWith('5')
            ? await searchPlanList_SUB(params)
            : await searchPlanList(params)
        } else {
          res = this.group && !this.group.startsWith('5')
            ? await searchActualList_SUB(params)
            : await searchActualList(params)
        }

        this.bas0010MainGrid = (res.list || []).map(x => ({
            ...x,
            workAct: x.workAct ? String(x.workAct).trim() : ''
          }))

          await this.buildWorkActAll(this.bas0010MainGrid)

          this.listWorkActAll = this.listWorkActAll.map(x => ({
            code: String(x.code).trim(),
            name: x.name
          }))

          this.bas0010MainGrid = [...this.bas0010MainGrid]
        
      } finally {
        this.endLoading()
      }
    },

    btnAdd() {
      const grid = this.gridMainInstance

      const focusedIndex = grid.option('focusedRowIndex')
      const row = grid.getVisibleRows()?.[focusedIndex]?.data

      if (!row) return

      const newRow = {
        empNo: row.empNo,
        empNm: row.empNm,
        fday: this.movDate,
        tday: this.movDate,
        __created__: true
      }

      grid.addRow()

      grid.option('editing.editRowKey', null)

      this.$nextTick(() => {
        const visibleRows = grid.getVisibleRows()

        // 
        const newRowIndex = visibleRows.findIndex(r => r.isNewRow)

        grid.cellValue(newRowIndex, 'empNo', newRow.empNo)
        grid.cellValue(newRowIndex, 'empNm', newRow.empNm)
        grid.cellValue(newRowIndex, 'fday', newRow.fday)
        grid.cellValue(newRowIndex, 'tday', newRow.tday)

        grid.option('focusedRowIndex', newRowIndex)
      })
      },
    async btnSave() {

        
    },
    async btnDelete() {

    },

  },
  mounted() {
    // console.log("writeYn: ", this.writeYn );
    this.btnCaption = false
    this.btnChief   = false

    let toDay = new Date
        toDay.setDate(toDay.getDate());
        this.movDate = toDay

    // setTimeout(() => this.gridMainInstance.refresh(), 100)
    // this.doSearchMainList(true)
  },
  created() {
    this.setCombo()
  },
  beforeMount() {
    let param = {
      makerCd: this.$store.state.user.makerCd,
      code: '',
      codegr: '',
      prtCode: 'TIME_FULL',
      userFlag: 'Y'
    }
    
  }
}
</script>
<style lang="less" scoped></style>
